import { useSelector, useDispatch } from 'react-redux';
import { getOpenCampaigns, getIsInitial, fetchOpenCampaigns } from './redux';
import { useEffect } from 'react';

export const useOpenCampaignsWithPrefetch = () => {
    const dispatch = useDispatch();
    const openCampaigns = useSelector(getOpenCampaigns) || [];
    const isInitial = useSelector(getIsInitial);

    useEffect(() => {
        if (isInitial) {
            dispatch(fetchOpenCampaigns());
        }
    }, []);

    return openCampaigns;
};
